import { NgModule } from '@angular/core';
import { DecodedPipe } from './decoded/decoded';
@NgModule({
	declarations: [DecodedPipe],
	imports: [],
	exports: [DecodedPipe]
})
export class PipesModule {}



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts